import { ReactNode } from 'react';
import { Button } from 'react-bootstrap';
import { DataTable } from '@shared/DataTable/DataTable';
import { exportToExcel } from '../../utils/exportToExcel';

interface BaseChartTableProps<T> {
  title: string;
  data: T[];
  headers: string[];
  renderRow: (row: T, index: number) => ReactNode;
  exportData: Record<string, any>[];
  exportFilename: string;
  hasSelection?: boolean;
  onResetSelection?: () => void;
  emptyMessage?: string;
}

export const BaseChartTable = <T,>({
  title,
  data,
  headers,
  renderRow,
  exportData,
  exportFilename,
  hasSelection = false,
  onResetSelection,
  emptyMessage = 'No hay datos disponibles',
}: BaseChartTableProps<T>) => {
  const handleExport = () => {
    if (exportData.length === 0) return;
    exportToExcel(exportData, exportFilename);
  };

  if (data.length === 0) {
    return (
      <div className="mt-4">
        <div className="text-muted">{emptyMessage}</div>
      </div>
    );
  }

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>
          {title} ({data.length})
        </h5>
        <div className="d-flex gap-2">
          {hasSelection && onResetSelection && (
            <Button
              variant="outline-secondary"
              onClick={onResetSelection}
              size="sm"
            >
              Ver todo
            </Button>
          )}
          <Button variant="outline-primary" onClick={handleExport} size="sm">
            Descargar Excel
          </Button>
        </div>
      </div>
      <DataTable
        headers={headers}
        data={data}
        renderRow={renderRow}
        emptyMessage={emptyMessage}
      />
    </div>
  );
};

